import React from "react";

export default function AboutUs() 
{
  return (
    <div className="container my-5">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-10">
          <div className="card shadow-sm">
            <div className="card-body">

              <h3 className="mb-4 text-center">About Us</h3>

              <p>
                <strong>SAMRIDHI CONSIGNMENTS PRIVATE LIMITED</strong> is a renowned
                Manpower Outsourcing, Training, Digital Marketing, Project Management
                Consultancy, and Staffing Solutions company based in Chandigarh (India).
                The company was established in 2018 and has steadily grown by delivering
                reliable and result-oriented solutions across India.
              </p>

              <p>
                Headquartered in Chandigarh, we have strong business interests in
                project management consultancy as well as in providing comprehensive
                staffing solutions. Over the years, we have developed several
                cutting-edge and customized software solutions in the field of
                manpower and staffing services.
              </p>

              <p>
                The company’s core practices focus on developing both generalized and
                customized solutions with total quality control and complete customer
                satisfaction. We strongly believe in understanding customer
                requirements in depth and delivering solutions that are practical,
                scalable, and efficient.
              </p>

              <p>
                Our primary aim is to build long-term, friendly relationships with our
                clients by identifying their exact needs and providing the best
                possible solutions tailored to their requirements across India.
              </p>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}